import styled from 'styled-components';
import { customMedia, defaultTransition } from 'styles/utils';

import { MOBILE_HEIGHT } from 'apps/components/header/header.styled';

import { defaultRow } from './mainNav.styled';

export const MobileNavViewport = styled.nav`
  position: fixed;
  top: ${MOBILE_HEIGHT + 1}px;
  left: 0;
  right: 0;
  width: 100vw;
  max-height: calc(100vh - ${MOBILE_HEIGHT + 1}px);
  transform-origin: top;
  transform: scaleY(${props => (props.show ? 1 : 0)});
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: rgb(67 90 111 / 42%) 0 0 1px, rgb(67 90 111 / 30%) 0 5px 8px -4px;
  ${defaultTransition('transform')}

  ${customMedia.greaterThan('large')`
    display: none;
  `}
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  background-color: ${props => props.theme.color.wfWhite};
  transform-origin: top;
  transform: translateY(${props => (props.show ? 0 : -100)}%);
  ${defaultTransition('transform')}
`;

export const RowWrapper = styled.li`
  ${defaultRow}
`;
